package com.klantenstop.web.pages.manageCompany.components

import androidx.compose.runtime.Composable
import com.materialkobweb.styles.MaterialColorVars
import com.klantenstop.web.utils.withAlpha
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px

@Composable
fun GuidanceCard(text: String, modifier: Modifier = Modifier) {
    SpanText(
        text = text,
        modifier = modifier
            .fillMaxWidth()
            .padding(12.px)
            .backgroundColor(MaterialColorVars.SecondaryContainer.value())
            .borderRadius(8.px)
            .border(1.px, LineStyle.Solid, MaterialColorVars.Secondary.withAlpha(0.3f))
            .fontSize(13.px)
            .color(MaterialColorVars.OnSecondaryContainer.value())
    )
}
